// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"e15d7f8d","487":"dba183cb"}[chunkId] + ".chunk.css";
};